module.exports = __webpack_public_path__ + "img/金属材料学3_4.4ffa4f26.png";